<page-toolbar [pageActions]="pageActions" title="{{'pages.legal' | translate}}" *ngIf="!noHeader"></page-toolbar>

<page-content [noPadding]="true">
  <mat-card appearance="outlined" *ngIf="!!myPackage && !!myPackage.legal" class="main-container">
    <h2>{{'packages.legal.dsgvoTitle' | translate }}</h2>
    <ibex-checkbox [title]="'packages.legal.dsgvoAsUrl' | translate" [checked]="myPackage.legal.dsgvo.asUrl" (click)="myPackage.legal.dsgvo.asUrl = $event.val"></ibex-checkbox>
    <mat-tab-group (selectedTabChange)="tabChange($event)">
      <mat-tab *ngFor="let lang of availableLanguages" [label]="'general.languages.' + lang | translate">
        <mat-card appearance="outlined" *ngIf="myPackage.legal.dsgvo.asUrl">
          <mat-form-field class="url">
            <input [(ngModel)]="myPackage.legal.dsgvo.url[lang]" [placeholder]="('packages.legal.dsgvoPlaceholder' | translate) + lang" matInput>
          </mat-form-field>
        </mat-card>
        <mat-card appearance="outlined" *ngIf="!myPackage.legal.dsgvo.asUrl">
          <editor (changeContent)="onEditorChange($event, 'dsgvo', lang)" *ngIf="currentLang === lang" [content]="myPackage.legal.dsgvo.text[lang]"></editor>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="!!myPackage && !!myPackage.legal" class="main-container">
    <h2>{{'packages.legal.agbTitle' | translate }}</h2>
    <ng-container *ngIf="myPackage.legal.agb">
      <ibex-checkbox [title]="'packages.legal.agbAsUrl' | translate" [checked]="myPackage.legal.agb.asUrl" (click)="myPackage.legal.agb.asUrl = $event.val"></ibex-checkbox>
      <mat-tab-group (selectedTabChange)="tabChangeAGB($event)">
        <mat-tab *ngFor="let lang of availableLanguages" [label]="'general.languages.' + lang | translate">
          <mat-card appearance="outlined" *ngIf="myPackage.legal.agb.asUrl">
            <mat-form-field class="url">
              <input [(ngModel)]="myPackage.legal.agb.url[lang]" [placeholder]="('packages.legal.agbPlaceholder' | translate) + lang" matInput>
            </mat-form-field>
          </mat-card>
          <mat-card appearance="outlined" *ngIf="!myPackage.legal.agb.asUrl">
            <editor (changeContent)="onEditorChange($event, 'agb', lang)" *ngIf="currentLangAGB === lang" [content]="myPackage.legal.agb.text[lang]"></editor>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
    <div class="button-right-container">
      <button (click)="addAGB()" *ngIf="!myPackage.legal.agb" class="ibexfusion-raised-button small" mat-button>{{'packages.legal.addAgb' | translate}}</button>
      <button (click)="removeAGB()" *ngIf="myPackage.legal.agb" class="ibexfusion-raised-button small" mat-button>{{'packages.legal.removeAgb' | translate}}</button>
    </div>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="!!myPackage && !!myPackage.legal" class="main-container">
    <h2>{{'packages.legal.imprintTitle' | translate }}</h2>
    <ng-container *ngIf="myPackage.legal.imprint">
      <ibex-checkbox [title]="'packages.legal.imprintAsUrl' | translate" [checked]="myPackage.legal.imprint.asUrl" (click)="myPackage.legal.imprint.asUrl = $event.val"></ibex-checkbox>
      <mat-tab-group (selectedTabChange)="tabChangeImprint($event)">
        <mat-tab *ngFor="let lang of availableLanguages" [label]="'general.languages.' + lang | translate">
          <mat-card appearance="outlined" *ngIf="myPackage.legal.imprint.asUrl">
            <mat-form-field class="url">
              <input [(ngModel)]="myPackage.legal.imprint.url[lang]" [placeholder]="('packages.legal.imprintPlaceholder' | translate) + lang" matInput>
            </mat-form-field>
          </mat-card>
          <mat-card appearance="outlined" *ngIf="!myPackage.legal.imprint.asUrl">
            <editor (changeContent)="onEditorChange($event, 'imprint', lang)" *ngIf="currentLangImprint === lang" [content]="myPackage.legal.imprint.text[lang]"></editor>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
    <div class="button-right-container">
      <button (click)="addImprint()" *ngIf="!myPackage.legal.imprint" class="ibexfusion-raised-button small" mat-button>{{'packages.legal.addImprint' | translate}}</button>
      <button (click)="removeImprint()" *ngIf="myPackage.legal.imprint" class="ibexfusion-raised-button small" mat-button>{{'packages.legal.removeImprint' | translate}}</button>
    </div>
  </mat-card>

  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</page-content>
